import { useTranslation } from "react-i18next";
import { isEmpty } from "../../utils/utils";

const Toast = ({ text, isError, action }) => {
  const icon = isError ? "/images/error_icon.svg" : "/images/info-icon.svg";
  const { t } = useTranslation();
  return (
    <div
      className={`az-toast-container ${isError ? "toast-error" : ""} mt-4 w-100`}
    >
      <div className="toast-main-content">
        <img
          className="toast-icon"
          src={process.env.PUBLIC_URL + icon}
          alt="info or error icon"
        />
        <span className="toast-text">{text}</span>
      </div>

      {isError && !isEmpty(action) && (
        <div onClick={action} className="toast-request">
          <img
            src={process.env.PUBLIC_URL + "/images/arrow-right.svg"}
            alt="Request new code arrow"
          />
          <span>{t("toast.request.code")}</span>
        </div>
      )}
    </div>
  );
};

export default Toast;
